import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import useMeta from "../hooks/useMeta";

export const LEGAL_DOCS = {
  "liability-waiver": { title: "Liability Waiver | Saviar", desc: "Saviar liability waiver for the 21-day Soft Life Reset cohort." },
  "assumption-of-risk": { title: "Assumption of Risk | Saviar", desc: "Saviar assumption of risk acknowledgment for cohort participants." },
  "participation-agreement": { title: "Participation Agreement | Saviar", desc: "Saviar participation agreement for the 21-day Soft Life Reset cohort." },
  "privacy-policy": { title: "Privacy Policy | Saviar", desc: "How Saviar LLC collects, uses, and protects your information." },
  "terms-and-conditions": { title: "Terms and Conditions | Saviar", desc: "Terms and conditions for saviar.org, Saviar memberships, programs, and products." },
};

function renderMarkdown(md) {
  const blocks = md.replace(/\r/g, "").split(/\n\s*\n/);
  return blocks.map((block, i) => {
    const lines = block.split("\n").filter((l) => l.trim() !== "");
    if (!lines.length) return null;
    const h = lines[0].match(/^(#{1,3})\s+(.*)$/);
    if (h && lines.length === 1) {
      const level = h[1].length;
      const Tag = `h${level}`;
      const size = level === 1 ? "clamp(2rem, 4vw, 3rem)" : level === 2 ? "1.5rem" : "1.2rem";
      return <Tag key={i} style={{ fontFamily: "var(--serif)", fontWeight: level === 1 ? 300 : 400, fontSize: size, color: "var(--charcoal)", margin: level === 1 ? "0 0 24px" : "40px 0 12px", lineHeight: 1.2 }}>{h[2]}</Tag>;
    }
    if (lines.every((l) => /^\s*-\s+/.test(l))) {
      return (
        <ul key={i} style={{ paddingLeft: 22, margin: "0 0 18px", listStyle: "disc" }}>
          {lines.map((l, j) => <li key={j} style={{ color: "var(--warm-gray)", lineHeight: 1.8, marginBottom: 6 }}>{l.replace(/^\s*-\s+/, "")}</li>)}
        </ul>
      );
    }
    return (
      <p key={i} style={{ color: "var(--warm-gray)", lineHeight: 1.85, margin: "0 0 18px" }}>
        {lines.map((l, j) => <span key={j}>{l}{j < lines.length - 1 && <br />}</span>)}
      </p>
    );
  });
}

export default function LegalPage({ slug }) {
  const doc = LEGAL_DOCS[slug];
  useMeta(doc.title, doc.desc);
  const [md, setMd] = useState("");
  useEffect(() => {
    setMd("");
    fetch(`/legal/${slug}.md`).then((r) => r.text()).then(setMd);
  }, [slug]);

  return (
    <div data-testid={`legal-page-${slug}`}>
      <Nav />
      <div style={{ background: "var(--charcoal)", height: 88 }} />
      <section className="section" style={{ background: "var(--ivory)" }}>
        <article className="container-x" style={{ maxWidth: 780 }} data-testid="legal-content">
          {md ? renderMarkdown(md) : <p className="body-sm">Loading…</p>}
        </article>
      </section>
      <Footer />
    </div>
  );
}
